module.exports = "/static/assets/fa5fc4fd0867378d64ecfdf3ebdb3fde.png";